namespace RioERP.Products {
    export interface UpdateFranchiseeShareForm {
        RowIds: Serenity.StringEditor;
        SharingAmount: Serenity.DecimalEditor;
    }

    export class UpdateFranchiseeShareForm extends Serenity.PrefixedContext {
        static formKey = 'RioERP.UpdateFranchiseeShareForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UpdateFranchiseeShareForm.init)  {
                UpdateFranchiseeShareForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(UpdateFranchiseeShareForm, [
                    'RowIds', w0,
                    'SharingAmount', w1
                ]);
            }
        }
    }
}
